/*
 * WebCRD
 * Web to print solution that automates ordering, fulfillment, job ticketing, production management and chargebacks across corporate print centers.
 * Copyright 1999-2026 Rochester Software Associates (service@rocsoft.com)
 */

import PropTypes from 'prop-types';
import { useCallback } from 'react';

import FormHelp from '~/components/inputs/FormHelp';

import { automationIDPropTypes } from '../id/AutomationID';
import localizedStringOrNode, { localizedStringOrNodePropTypes } from '../text/LocalizedStringOrNode';

const Checkbox = ({ automationID, label, checked, setChecked, help, title, allowLocalizationMode = true }) => {
    const { id } = automationID;
    const helpID = help && automationID && `${automationID.id}__help` || 'help';

    const onChange = useCallback(
        (event) => {
            setChecked(event.target.checked);
        },
        [setChecked]
    );

    return (
        <div className="form-check">
            <input
                title={title}
                className="form-check-input"
                type="checkbox"
                id={id}
                checked={checked}
                onChange={onChange}
                disabled={!setChecked}
            />
            <label className="form-check-label" htmlFor={id}>{localizedStringOrNode(label, allowLocalizationMode)}</label>
            <FormHelp helpID={helpID} help={help} />
        </div>
    );
};

Checkbox.propTypes = {
    automationID: automationIDPropTypes,
    label: localizedStringOrNodePropTypes.isRequired,
    checked: PropTypes.bool,
    setChecked: PropTypes.func,
    help: PropTypes.node,
    title: PropTypes.string,
    allowLocalizationMode: PropTypes.bool,
};

export default Checkbox;
